import { render } from "./Loader.vue?vue&type=template&id=37c744dc&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=37c744dc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-37c744dc"

export default script